import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const TextGlowScaleListItem = (props) => {
    const { glowSettingsScale, updateTextElement, index, maxGlowScale } = props;
    
    const onGlowScaleChange = (value) => {
        previewHistoryBatch.start();
        
        updateTextElement(index, { 
            glowSettings: { scale: value } 
        });
    };
    
    return (
        <SliderListItem
            title='Scale'
            value={glowSettingsScale}
            displayMultiplier={100 / maxGlowScale}
            min={0}
            max={100}
            step={1}
            onValueChange={onGlowScaleChange}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const element = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    const glowSettingsScale = element && element.glowSettings ? element.glowSettings.scale : 0;
    const { maxGlowScale } = state.create.maxValues;

    return { 
        glowSettingsScale,
        maxGlowScale
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextGlowScaleListItem);
